import { REVENUE_MANAGEMENT_ROOT_ENDPOINT } from "./RootEndpoint";

const PATH_FLASH_MANAGER = `${REVENUE_MANAGEMENT_ROOT_ENDPOINT}/flash-manager`;

export const FLASH_MANAGER_GET_ALL = PATH_FLASH_MANAGER;
export const FLASH_MANAGER_EXPORT_PDF = `${PATH_FLASH_MANAGER}/export`;
